import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIgdChartsDataContext } from './hooks/useIgdChartsDataContext';

export const AnualEvolution = () => {
    const { chartData } = useIgdChartsDataContext();

    return (
        <SimpleBars
            title={'Evolução Anual do IGD-M'}
            horizontal={false}
            subtitles={chartData?.anualEvolution?.map((item) => getYearLabel(item.ano))}
            values={chartData?.anualEvolution?.map((item) => item.value  ||  0)}
        />
    );
};
